import type { Dispatch, Middleware } from '@reduxjs/toolkit';
import { adminApi } from './admin';
import { bookingApi } from './booking';
import { calculatorPackagesApi } from './calculatorPackages';
import { campaignApi } from './campaign';
import { channelApi } from './channel';
import { clientApi } from './client';
import { eu6CalculatorApi } from './eu6Calculator';
import { forecastingApi } from './forecasting';
import { ioTemplateApi } from './ioTemplate';
import { mediaPlanApi } from './mediaPlan';
import { pandaDocApi } from './pandaDoc';
import { pdfApi } from './pdf';
import { rateCardApi } from './rateCard';
import { userApi } from './user';

/**
 * Every RTK Query API slice in the app, in one place.
 *
 * The store builds its middleware from this list and sign-out clears every
 * cache through it, so a new API only has to be added here (and to the
 * store's reducers) to get both.
 */
export const API_SLICES = [
  adminApi,
  bookingApi,
  mediaPlanApi,
  userApi,
  clientApi,
  channelApi,
  rateCardApi,
  campaignApi,
  pdfApi,
  eu6CalculatorApi,
  calculatorPackagesApi,
  forecastingApi,
  pandaDocApi,
  ioTemplateApi
] as const;

/** Middleware for every API slice, for `configureStore`. */
export const apiMiddleware: Middleware[] = API_SLICES.map((api) => api.middleware);

/**
 * Drops every cached query result.
 *
 * Run on sign-out: otherwise the next person to sign in on this browser is
 * served the previous user's cached plans, rate cards and reports until each
 * query refetches — data their role may not be allowed to see.
 *
 * @param dispatch - The store's dispatch.
 */
export const resetAllApiState = (dispatch: Dispatch): void => {
  API_SLICES.forEach((api) => dispatch(api.util.resetApiState()));
};
